import React, { useState } from "react"
import { GenerateQRCodeService } from "../../../Services/Generate";
import DownloadImage from "../download-image";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { InputColor } from "./input-color";

const GenerateQRCode: React.FunctionComponent<{}> = (props) => {

    const [isGenerated, setIsGenerated] = useState<boolean>(false);
    const [imageValue, setImageValue] = useState<any>("");
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [colorSnackbar, setColorSnackbar] = useState<any>("");
    const [message, setMessage] = useState<string>();
    const [type, setType] = useState<any>("Link");
    const [url, setUrl] = useState<any>("");
    const [color, setColor] = useState<any>("");
    const [email, setEmail] = useState<any>("");
    const [subjectOfEmail, setSubjectOfEmail] = useState<any>("");
    const [countryCode, setCountryCode] = useState<any>("");
    const [fullName, setFullName] = useState<any>("");
    const [phone, setPhone] = useState<any>("");
    const [jobTitle, setJobTitle] = useState<any>("");
    const [company, setCompany] = useState<any>("");
    const [error, setError] = useState<any>();
    const [listCountry, setListCountry] = useState<any>([
        { country: "Afghanistan", code: "93" },
        { country: "Albania", code: "355" },
        { country: "Algeria", code: "213" },
        { country: "Andorra", code: "376" },
        { country: "Angola", code: "244" },
        { country: "Antigua and Barbuda", code: "1268" },
        { country: "Argentina", code: "54" },
        { country: "Armenia", code: "374" },
        { country: "Australia", code: "61" },
        { country: "Austria", code: "43" },
        { country: "Azerbaijan", code: "994" },
        { country: "Bahamas", code: "1242" },
        { country: "Bahrain", code: "973" },
        { country: "Bangladesh", code: "880" },
        { country: "Barbados", code: "1246" },
        { country: "Belarus", code: "375" },
        { country: "Belgium", code: "32" },
        { country: "Belize", code: "501" },
        { country: "Benin", code: "229" },
        { country: "Bhutan", code: "975" },
        { country: "Bolivia", code: "591" },
        { country: "Bosnia and Herzegovina", code: "387" },
        { country: "Botswana", code: "267" },
        { country: "Brazil", code: "55" },
        { country: "Brunei", code: "673" },
        { country: "Bulgaria", code: "359" },
        { country: "Burkina Faso", code: "226" },
        { country: "Burundi", code: "257" },
        { country: "Cabo Verde", code: "238" },
        { country: "Cambodia", code: "855" },
        { country: "Cameroon", code: "237" },
        { country: "Canada", code: "1" },
        { country: "Central African Republic", code: "236" },
        { country: "Chad", code: "235" },
        { country: "Chile", code: "56" },
        { country: "China", code: "86" },
        { country: "Colombia", code: "57" },
        { country: "Comoros", code: "269" },
        { country: "Congo", code: "242" },
        { country: "Costa Rica", code: "506" },
        { country: "Croatia", code: "385" },
        { country: "Cuba", code: "53" },
        { country: "Cyprus", code: "357" },
        { country: "Czech Republic", code: "420" },
        { country: "Denmark", code: "45" },
        { country: "Djibouti", code: "253" },
        { country: "Dominica", code: "1767" },
        { country: "Dominican Republic", code: "1809" },
        { country: "Ecuador", code: "593" },
        { country: "Egypt", code: "20" },
        { country: "El Salvador", code: "503" },
        { country: "Equatorial Guinea", code: "240" },
        { country: "Eritrea", code: "291" },
        { country: "Estonia", code: "372" },
        { country: "Eswatini", code: "268" },
        { country: "Ethiopia", code: "251" },
        { country: "Fiji", code: "679" },
        { country: "Finland", code: "358" },
        { country: "France", code: "33" },
        { country: "Gabon", code: "241" },
        { country: "Gambia", code: "220" },
        { country: "Georgia", code: "995" },
        { country: "Germany", code: "49" },
        { country: "Ghana", code: "233" },
        { country: "Greece", code: "30" },
        { country: "Grenada", code: "1473" },
        { country: "Guatemala", code: "502" },
        { country: "Guinea", code: "224" },
        { country: "Guinea-Bissau", code: "245" },
        { country: "Guyana", code: "592" },
        { country: "Haiti", code: "509" },
        { country: "Honduras", code: "504" },
        { country: "Hungary", code: "36" },
        { country: "Iceland", code: "354" },
        { country: "India", code: "91" },
        { country: "Indonesia", code: "62" },
        { country: "Iran", code: "98" },
        { country: "Iraq", code: "964" },
        { country: "Ireland", code: "353" },
        { country: "Israel", code: "972" },
        { country: "Italy", code: "39" },
        { country: "Jamaica", code: "1876" },
        { country: "Japan", code: "81" },
        { country: "Jordan", code: "962" },
        { country: "Kazakhstan", code: "7" },
        { country: "Kenya", code: "254" },
        { country: "Kiribati", code: "686" },
        { country: "Kuwait", code: "965" },
        { country: "Kyrgyzstan", code: "996" },
        { country: "Laos", code: "856" },
        { country: "Latvia", code: "371" },
        { country: "Lebanon", code: "961" },
        { country: "Lesotho", code: "266" },
        { country: "Liberia", code: "231" },
        { country: "Libya", code: "218" },
        { country: "Liechtenstein", code: "423" },
        { country: "Lithuania", code: "370" },
        { country: "Luxembourg", code: "352" },
        { country: "Madagascar", code: "261" },
        { country: "Malawi", code: "265" },
        { country: "Malaysia", code: "60" },
        { country: "Maldives", code: "960" },
        { country: "Mali", code: "223" },
        { country: "Malta", code: "356" },
        { country: "Marshall Islands", code: "692" },
        { country: "Mauritania", code: "222" },
        { country: "Mauritius", code: "230" },
        { country: "Mexico", code: "52" },
        { country: "Micronesia", code: "691" },
        { country: "Moldova", code: "373" },
        { country: "Monaco", code: "377" },
        { country: "Mongolia", code: "976" },
        { country: "Montenegro", code: "382" },
        { country: "Morocco", code: "212" },
        { country: "Mozambique", code: "258" },
        { country: "Myanmar", code: "95" },
        { country: "Namibia", code: "264" },
        { country: "Nauru", code: "674" },
        { country: "Nepal", code: "977" },
        { country: "Netherlands", code: "31" },
        { country: "New Zealand", code: "64" },
        { country: "Nicaragua", code: "505" },
        { country: "Niger", code: "227" },
        { country: "Nigeria", code: "234" },
        { country: "North Korea", code: "850" },
        { country: "North Macedonia", code: "389" },
        { country: "Norway", code: "47" },
        { country: "Oman", code: "968" },
        { country: "Pakistan", code: "92" },
        { country: "Palau", code: "680" },
        { country: "Palestine", code: "970" },
        { country: "Panama", code: "507" },
        { country: "Papua New Guinea", code: "675" },
        { country: "Paraguay", code: "595" },
        { country: "Peru", code: "51" },
        { country: "Philippines", code: "63" },
        { country: "Poland", code: "48" },
        { country: "Portugal", code: "351" },
        { country: "Qatar", code: "974" },
        { country: "Romania", code: "40" },
        { country: "Russia", code: "7" },
        { country: "Rwanda", code: "250" },
        { country: "Saint Kitts and Nevis", code: "1869" },
        { country: "Saint Lucia", code: "1758" },
        { country: "Saint Vincent and the Grenadines", code: "1784" },
        { country: "Samoa", code: "685" },
        { country: "San Marino", code: "378" },
        { country: "Sao Tome and Principe", code: "239" },
        { country: "Saudi Arabia", code: "966" },
        { country: "Senegal", code: "221" },
        { country: "Serbia", code: "381" },
        { country: "Seychelles", code: "248" },
        { country: "Sierra Leone", code: "232" },
        { country: "Singapore", code: "65" },
        { country: "Slovakia", code: "421" },
        { country: "Slovenia", code: "386" },
        { country: "Solomon Islands", code: "677" },
        { country: "Somalia", code: "252" },
        { country: "South Africa", code: "27" },
        { country: "South Korea", code: "82" },
        { country: "South Sudan", code: "211" },
        { country: "Spain", code: "34" },
        { country: "Sri Lanka", code: "94" },
        { country: "Sudan", code: "249" },
        { country: "Suriname", code: "597" },
        { country: "Sweden", code: "46" },
        { country: "Switzerland", code: "41" },
        { country: "Syria", code: "963" },
        { country: "Taiwan", code: "886" },
        { country: "Tajikistan", code: "992" },
        { country: "Tanzania", code: "255" },
        { country: "Thailand", code: "66" },
        { country: "Timor-Leste", code: "670" },
        { country: "Togo", code: "228" },
        { country: "Tonga", code: "676" },
        { country: "Trinidad and Tobago", code: "1868" },
        { country: "Tunisia", code: "216" },
        { country: "Turkey", code: "90" },
        { country: "Turkmenistan", code: "993" },
        { country: "Tuvalu", code: "688" },
        { country: "Uganda", code: "256" },
        { country: "Ukraine", code: "380" },
        { country: "United Arab Emirates", code: "971" },
        { country: "United Kingdom", code: "44" },
        { country: "United States of America", code: "1" },
        { country: "Uruguay", code: "598" },
        { country: "Uzbekistan", code: "998" },
        { country: "Vanuatu", code: "678" },
        { country: "Vatican City", code: "379" },
        { country: "Venezuela", code: "58" },
        { country: "Vietnam", code: "84" },
        { country: "Yemen", code: "967" },
        { country: "Zambia", code: "260" },
        { country: "Zimbabwe", code: "263" }
    ])
    const { t } = useTranslation();

    const handleChangeColor = (value: any) => {
        if (value.startsWith("#")) value = value.slice(1);
        setColor(value)
    }

    const handleChangeType = (value: any) => {
        setType(value)
        setUrl("")
        setError("")
        setEmail("")
        setSubjectOfEmail("")
        setMessage("")
        setCountryCode("")
        setFullName("")
        setPhone("")
        setJobTitle("")
        setCompany("")
    }
    const handleChangeUrl = (event: any) => {
        setUrl(event.target.value)
    }
    const handleChangeEmail = (event: any) => {
        setEmail(event.target.value)
        if (event.target.value && !event.target.value.match(/^[A-Za-z\._\-[0-9]*[@][A-Za-z]*[\.][a-z]{2,4}$/)) {
            setError('Please enter your email in the correct format');
        }
        else {
            setError('');
        }
    }
    const handleChangeSubjectOfEmail = (event: any) => {
        setSubjectOfEmail(event.target.value)
    }
    const handleChangeMessage = (event: any) => {
        setMessage(event.target.value)
    }
    const handleChangeCountryCode = (event: any, newValue: any) => {
        if (newValue) {
            setCountryCode(newValue.code)
        };
    }
    const handleChangeFullName = (event: any) => {
        setFullName(event.target.value)
    }
    const handleChangePhone = (event: any) => {
        setPhone(event.target.value)
    }
    const handleChangeJobTitle = (event: any) => {
        setJobTitle(event.target.value)
    }
    const handleChangeCompany = (event: any) => {
        setCompany(event.target.value)
    }

    const Generate = () => {
        setIsGenerated(true);

        if (type === "Link") {
            const objLink = {
                "type": "Link",
                "link": url,
                "color": color
            }
            GenerateQRCodeService(objLink).then((data) => {
                setImageValue(data.data[0].src + '?timestamp=' + new Date().getTime())
                setIsGenerated(false)
                setColorSnackbar("success");
                setOpenSnackbar(true);
                setMessage("QR Code Generated Successfully !");
            })
                .catch(err => {
                    setColorSnackbar("error");
                    setOpenSnackbar(true);
                    setMessage("Failed to generate QR Code. Please try again.");
                })
        }
        if (type === "Email") {
            const objEmail = {
                "type": "Email",
                "email": email,
                "subject_of_email": subjectOfEmail,
                "message": message,
                "color": color
            }
            GenerateQRCodeService(objEmail).then((data) => {
                setImageValue(data.data[0].src + '?timestamp=' + new Date().getTime())
                setIsGenerated(false)
                setColorSnackbar("success");
                setOpenSnackbar(true);
                setMessage("QR Code Generated Successfully !");
            })
                .catch(err => {
                    setColorSnackbar("error");
                    setOpenSnackbar(true);
                    setMessage("Failed to generate QR Code. Please try again.");
                })
        }
        if (type === "Call") {
            const objCall = {
                "type": "Call",
                "country_code": countryCode,
                "phone_number": phone,
                "color": color
            }
            GenerateQRCodeService(objCall).then((data) => {
                setImageValue(data.data[0].src + '?timestamp=' + new Date().getTime())
                setIsGenerated(false)
                setColorSnackbar("success");
                setOpenSnackbar(true);
                setMessage("QR Code Generated Successfully !");
            })
                .catch(err => {
                    setColorSnackbar("error");
                    setOpenSnackbar(true);
                    setMessage("Failed to generate QR Code. Please try again.");
                })
        }
        else if (type === "V Card") {
            const objCard = {
                "type": "V Card",
                "full_name": fullName,
                "email": email,
                "phone_number": countryCode + phone,
                "job_title": jobTitle,
                "company": company,
                "color": color
            }
            GenerateQRCodeService(objCard).then((data) => {
                setImageValue(data.data[0].src + '?timestamp=' + new Date().getTime())
                setIsGenerated(false)
                setColorSnackbar("success");
                setOpenSnackbar(true);
                setMessage("QR Code Generated Successfully !");
            })
                .catch(err => {
                    setColorSnackbar("error");
                    setOpenSnackbar(true);
                    setMessage("Failed to generate QR Code. Please try again.");
                })

        }
    }


    const HandleCopy = () => {
        navigator.clipboard.writeText(imageValue);
        setColorSnackbar("success");
        setOpenSnackbar(true);
        setMessage("QR Code Copied Successfully !");
    }

    const handleCloseSnackbar = (
        event?: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    }



    return (
        <>
            <div className="row padd-20 ">
                <div className="col-md-5 ">
                    <div className="card-F1F5F9 padd-20">
                        <div className="btn-group environment mb-4" id="environment" >
                            <button type="button" className={`btn ${type === "Link" ? "active" : ""}`} onClick={() => handleChangeType("Link")} >
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_830_9847)">
                                        <path d="M6.75 11.25L11.25 6.75" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M8.25 4.50023L8.59725 4.09823C9.3006 3.39497 10.2545 2.99993 11.2491 3C12.2438 3.00007 13.1976 3.39525 13.9009 4.0986C14.6041 4.80196 14.9992 5.75587 14.9991 6.75049C14.999 7.74512 14.6039 8.69898 13.9005 9.40223L13.5 9.75023" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M9.75011 13.5L9.45236 13.9005C8.74079 14.6041 7.78045 14.9988 6.77973 14.9988C5.77902 14.9988 4.81867 14.6041 4.10711 13.9005C3.75637 13.5537 3.47793 13.1408 3.28789 12.6856C3.09785 12.2304 3 11.7421 3 11.2489C3 10.7556 3.09785 10.2673 3.28789 9.81214C3.47793 9.35698 3.75637 8.94405 4.10711 8.59725L4.50011 8.25" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_830_9847">
                                            <rect width="18" height="18" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                {t("qrCode.link")}
                            </button>
                            <button type="button" className={`btn ${type === "Email" ? "active" : ""}`} onClick={() => handleChangeType("Email")}  >
                                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_830_9854)">
                                        <path d="M17 5.65137V12.7501C17 13.324 16.7808 13.8763 16.387 14.2938C15.9933 14.7114 15.4549 14.9627 14.882 14.9964L14.75 15.0001H4.25C3.67609 15.0001 3.12386 14.7809 2.7063 14.3872C2.28874 13.9934 2.03742 13.455 2.00375 12.8821L2 12.7501V5.65137L9.08375 10.3741L9.17075 10.4236C9.27328 10.4737 9.38589 10.4998 9.5 10.4998C9.61411 10.4998 9.72672 10.4737 9.82925 10.4236L9.91625 10.3741L17 5.65137Z" fill="white" />
                                        <path d="M14.7502 3C15.5602 3 16.2705 3.4275 16.6665 4.07025L9.50024 8.84775L2.33398 4.07025C2.52203 3.76483 2.78039 3.5088 3.08752 3.32354C3.39464 3.13827 3.74161 3.02914 4.09948 3.00525L4.25023 3H14.7502Z" fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_830_9854">
                                            <rect width="18" height="18" fill="white" transform="translate(0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                {t("qrCode.email")}
                            </button>
                            <button type="button" className={`btn ${type === "Call" ? "active" : ""}`} onClick={() => handleChangeType("Call")} >
                                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_830_9860)">
                                        <path d="M7.25 2.25C7.38446 2.24996 7.51646 2.28607 7.63218 2.35455C7.7479 2.42303 7.84307 2.52136 7.90775 2.63925L7.946 2.72175L9.446 6.47175C9.50641 6.62262 9.51619 6.78903 9.47385 6.94594C9.43151 7.10284 9.33936 7.24175 9.21125 7.34175L9.13625 7.39275L7.88075 8.14575L7.928 8.223C8.52557 9.17174 9.32826 9.97443 10.277 10.572L10.3535 10.6185L11.1073 9.3645C11.1908 9.22506 11.3174 9.11654 11.4679 9.05526C11.6185 8.99398 11.7848 8.98328 11.942 9.02475L12.0283 9.054L15.7783 10.554C15.9031 10.6038 16.0123 10.6863 16.0944 10.7928C16.1764 10.8992 16.2284 11.0258 16.2448 11.1592L16.25 11.25V14.25C16.25 15.4927 15.2428 16.5 13.955 16.4985C7.52075 16.1077 2.3915 10.9785 2 4.5C1.99997 3.92609 2.21924 3.37386 2.61296 2.9563C3.00668 2.53874 3.54508 2.28742 4.118 2.25375L4.25 2.25H7.25Z" fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_830_9860">
                                            <rect width="18" height="18" fill="white" transform="translate(0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                {t("qrCode.call")}
                            </button>
                            <button type="button" className={`btn ${type === "V Card" ? "active" : ""}`} onClick={() => handleChangeType("V Card")} style={{ marginRight: "0px" }}>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_830_9865)">
                                        <path d="M9 14.25H4.5C3.90326 14.25 3.33097 14.0129 2.90901 13.591C2.48705 13.169 2.25 12.5967 2.25 12V6C2.25 5.40326 2.48705 4.83097 2.90901 4.40901C3.33097 3.98705 3.90326 3.75 4.5 3.75H13.5C14.0967 3.75 14.669 3.98705 15.091 4.40901C15.5129 4.83097 15.75 5.40326 15.75 6V9.375" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M2.25 7.5H15.75" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 14.25H16.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M14.25 12L16.5 14.25L14.25 16.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M5.25391 11.25H5.25891" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M8.25 11.25H9.75" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_830_9865">
                                            <rect width="18" height="18" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                {t("qrCode.vcard")}
                            </button>
                        </div>
                        {type === "Link" && <>

                            <label className="form-label bold-700 mb-2 padd-00" htmlFor="Submit">{t("qrCode.submitUrl")}</label>
                            <input type="text" className=" form-control border-BEBDBD border-10 back-trans height-50 mb-3" placeholder="https://" onChange={handleChangeUrl} value={url} />

                            <label className="form-label bold-700 mb-2 padd-00" htmlFor="Color Code">{t("qrCode.colorCode")}</label>
                            <InputColor onChangColor={handleChangeColor} />

                            <button type="button" className={`button-dash back-746AFF color-FFFFFF bold-600 border-746AFF padd-15-30 width-auto ${url ? "" : "disabled"}`} onClick={Generate}>{t("qrCode.generate")}
                                {isGenerated && <div className="col-auto marg-left-5">
                                    <div className="spinner-border spinner-white" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            </button>

                        </>}
                        {type === "Email" && <>
                            <div>
                                <label className="form-label bold-700 mb-2 padd-00">{t("qrCode.emailAddress")}</label>
                                <input type="email" className="form-control border-BEBDBD border-10 back-trans height-50 mb-3" placeholder={t("qrCode.yourEmailAddress")} onChange={handleChangeEmail} value={email} />
                                {error && <span className="error">{t("qrCode.emailError")}</span>}
                            </div>
                            <label className="form-label bold-700 mb-2 padd-00">{t("qrCode.subjectOfEmail")}</label>
                            <input type="text" className="form-control border-BEBDBD border-10 back-trans height-50 mb-3" placeholder={t("qrCode.subjectOfEmail")} onChange={handleChangeSubjectOfEmail} value={subjectOfEmail} />

                            <label className="form-label bold-700 mb-2 padd-00">{t("qrCode.message")}</label>
                            <textarea className="form-control border-BEBDBD border-10 back-trans height-50 mb-3" style={{ maxHeight: "80px", minHeight: "50px" }} placeholder={t("qrCode.message")} onChange={handleChangeMessage} value={message} />

                            <label className="form-label bold-700 mb-2 padd-00" htmlFor="Color Code">{t("qrCode.colorCode")}</label>
                            <InputColor onChangColor={handleChangeColor} />

                            <button type="button" className={`button-dash back-746AFF color-FFFFFF bold-600 border-746AFF padd-15-30 width-auto  ${email && subjectOfEmail && message ? "" : "disabled"}`} onClick={Generate}>{t("qrCode.generate")}
                                {isGenerated && <div className="col-auto marg-left-5">
                                    <div className="spinner-border spinner-white" style={{ width: "20px", height: "20px" }} role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            </button>

                        </>}
                        {type === "Call" && <>
                            <div className="row">
                                <div className="col-md-4" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                                    <label className="form-label bold-700 mb-2 padd-00">{t("qrCode.countryCode")}</label>
                                    <Autocomplete
                                        options={listCountry}
                                        id="combo-box-d"
                                        getOptionLabel={(obj: any) => {
                                            return `${obj.country}`;
                                        }}
                                        className=" border-BEBDBD border-10 back-trans height-50 mb-3"
                                        disablePortal
                                        renderInput={(params) => <TextField {...params} onChange={(value: any) => {
                                            setCountryCode(value.target.value)
                                        }} />}
                                        onChange={handleChangeCountryCode}
                                    />
                                </div>
                                <div className="col-md-8" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                                    <label className="form-label bold-700 mb-2 padd-00">{t("qrCode.phoneNumber")}</label>
                                    <input type="text" className="form-control border-BEBDBD border-10 back-trans height-50 mb-3" placeholder={t("qrCode.phoneNumber")} onChange={handleChangePhone} value={phone} />
                                </div>
                            </div>
                            <label className="form-label bold-700 mb-2 padd-00" htmlFor="Color Code">{t("qrCode.colorCode")}</label>
                            <InputColor onChangColor={handleChangeColor} />

                            <button type="button" className={`button-dash back-746AFF color-FFFFFF bold-600 border-746AFF padd-15-30 width-auto  ${countryCode && phone ? "" : "disabled"}`} onClick={Generate}>{t("qrCode.generate")}
                                {isGenerated && <div className="col-auto marg-left-5">
                                    <div className="spinner-border spinner-white" style={{ width: "20px", height: "20px" }} role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            </button>

                        </>
                        }
                        {type === "V Card" && <>

                            <label className="form-label bold-700 mb-2 padd-00">{t("qrCode.fullName")}</label>
                            <input type="text" className="form-control border-BEBDBD border-10 back-trans height-50 mb-3" placeholder={t("qrCode.fullName")} onChange={handleChangeFullName} value={fullName} />

                            <label className="form-label bold-700 mb-2 padd-00">{t("qrCode.E-mail")}</label>
                            <input type="email" className="form-control border-BEBDBD border-10 back-trans height-50 mb-3" placeholder={t("qrCode.email")} onChange={handleChangeEmail} value={email} />

                            <div className="row">
                                <div className="col-md-4" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                                    <label className="form-label bold-700 mb-2 padd-00">{t("qrCode.countryCode")}</label>
                                    <Autocomplete
                                        options={listCountry}
                                        id="combo-box-d"
                                        getOptionLabel={(obj: any) => {
                                            return `${obj.country}`;
                                        }}
                                        disablePortal
                                        className=" border-BEBDBD border-10 back-trans height-50 mb-3"
                                        renderInput={(params) => <TextField {...params} onChange={(value) => {
                                            setCountryCode(value.target.value)
                                        }} />}
                                        onChange={handleChangeCountryCode}
                                    />
                                </div>
                                <div className="col-md-8" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                                    <label className="form-label bold-700 mb-2 padd-00">{t("qrCode.phoneNumber")}</label>
                                    <input type="text" className="form-control border-BEBDBD border-10 back-trans height-50 mb-3" placeholder={t("qrCode.phoneNumber")} onChange={handleChangePhone} value={phone} />
                                </div>

                            </div>
                            <label className="form-label bold-700 mb-2 padd-00">{t("qrCode.jobTitle")}</label>
                            <input type="text" className="form-control border-BEBDBD border-10 back-trans height-50 mb-3" placeholder={t("qrCode.jobTitle")} onChange={handleChangeJobTitle} value={jobTitle} />

                            <label className="form-label bold-700 mb-2 padd-00">{t("qrCode.company")}</label>
                            <input type="text" className="form-control border-BEBDBD border-10 back-trans height-50 mb-3" placeholder={t("qrCode.company")} onChange={handleChangeCompany} value={company} />

                            <label className="form-label bold-700 mb-2 padd-00" htmlFor="Color Code">{t("qrCode.colorCode")}</label>
                            <InputColor onChangColor={handleChangeColor} />

                            <button type="button" className={`button-dash back-746AFF color-FFFFFF bold-600 border-746AFF padd-15-30 width-auto  ${fullName && email && phone && jobTitle && countryCode && company ? "" : "disabled"}`} onClick={Generate}>{t("qrCode.generate")}
                                {isGenerated && <div className="col-auto marg-left-5">
                                    <div className="spinner-border spinner-white" style={{ width: "20px", height: "20px" }} role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            </button>

                        </>}
                    </div>
                </div>
                <div className="col-md-7 ">
                    <div className="card-F1F5F9 padd-20 mb-4">
                        <div className="card-image-gener">
                            {imageValue && <img src={imageValue} />}
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <button className="button-reset back-FFFFFF color-746AFF width-auto border-746AFF padd-15 marg-right-16" onClick={HandleCopy}>
                            <svg width="16" height="16" className="marg-right-5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.87 3.8165C14.7923 3.64553 14.687 3.48845 14.5585 3.3515L11.6485 0.4415C11.3655 0.160735 10.9836 0.00221049 10.585 0L6.5 0C5.673 0 5 0.673 5 1.5V2H2.5C1.673 2 1 2.673 1 3.5V14.5C1 15.327 1.673 16 2.5 16H9.5C10.327 16 11 15.327 11 14.5V14H13.5C14.327 14 15 13.327 15 12.5V4.415C15 4.205 14.953 4.0025 14.87 3.8165ZM13.2925 3.5H12C11.8674 3.5 11.7402 3.44732 11.6464 3.35355C11.5527 3.25979 11.5 3.13261 11.5 3V1.707L13.2925 3.5ZM10 14.5C10 14.6326 9.94732 14.7598 9.85355 14.8536C9.75979 14.9473 9.63261 15 9.5 15H2.5C2.2245 15 2 14.776 2 14.5V3.5C2 3.224 2.2245 3 2.5 3H6.5V5C6.5 5.827 7.173 6.5 8 6.5H10V14.5ZM9.293 5.5H8C7.7245 5.5 7.5 5.276 7.5 5V3.707L9.293 5.5ZM13.5 13H11V6.414C11 6.034 10.8335 5.6265 10.5605 5.3535L7.6465 2.4395C7.364 2.15975 6.98306 2.00196 6.5855 2H6V1.5C6 1.224 6.2245 1 6.5 1H10.5V3C10.5 3.827 11.173 4.5 12 4.5H14V12.5C14 12.6326 13.9473 12.7598 13.8536 12.8536C13.7598 12.9473 13.6326 13 13.5 13Z" fill="#6366F1" />
                            </svg> {t("qrCode.copy")}
                        </button>
                        <DownloadImage imageValue={imageValue} />
                    </div>
                </div>
            </div>

            <Snackbar open={openSnackbar}  onClose={handleCloseSnackbar}>
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={colorSnackbar || "info"}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default GenerateQRCode;